import vehicleMediaGallery from './components/vehicleMediaGallery';
import onlineShopper from "./components/onlineShopper";
import srpResultsNav from './components/srpResultsNav';
import askAQuestion from './components/askAQuestion';


export default async function initClient() {
    let listingDataElement = document.getElementById('listingJson');
    let employeesDataElement = document.getElementById('employeesJson');
    let featureFlagsDataElement = document.getElementById('featureFlagsJson');

    window.listing = deepFreeze(JSON.parse(listingDataElement.textContent));

    //didn't freeze this on purpose, something in app mutates it?
    window.employees = JSON.parse(employeesDataElement.textContent);

    window.featureFlags = deepFreeze(JSON.parse(featureFlagsDataElement.textContent));

    if (listingDataElement.parentNode !== null) {
        listingDataElement.parentNode.removeChild(listingDataElement);
    }

    if (employeesDataElement.parentNode !== null) {
        employeesDataElement.parentNode.removeChild(employeesDataElement);
    }

    if (featureFlagsDataElement.parentNode !== null) {
        featureFlagsDataElement.parentNode.removeChild(featureFlagsDataElement);
    }


    const vehicleMediaGalleryPromise = new Promise((resolve, reject) => {
        const vmg = vehicleMediaGallery();
        if (window.performance && window.performance.mark) {
            window.performance.mark('vdpCarousel');
        }
        resolve(vmg);
    });

    const srpResults = new Promise((resolve, reject) => {
        resolve(srpResultsNav(window));
    });

    onlineShopper();

    let askQuestionElement = document.querySelector('[ask-a-question]');

    if (askQuestionElement){
        askAQuestion(askQuestionElement);
    }


    await Promise.all([
        vehicleMediaGalleryPromise,
        srpResults
    ]);
}

function deepFreeze(object) {

    // Retrieve the property names defined on object
    var propNames = Object.getOwnPropertyNames(object);

    // Freeze properties before freezing self

    for (let name of propNames) {
        let value = object[name];

        object[name] = value && typeof value === "object" ?
            deepFreeze(value) : value;
    }

    return Object.freeze(object);
}